function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { bool, string } from 'prop-types';
import SemanticImage from "semantic-ui-react/dist/es/elements/Image/Image.js";
import { ImagePlaceholder } from "../ImagePlaceholder";
import { IMAGE_TITLE } from "../../../utils/default-strings";
import { Paragraph } from "../../typography/Paragraph";
import { testidFactory } from "../../../utils/testid";
var TESTID_PREFIX = 'responsive-image';
var testid = testidFactory(TESTID_PREFIX);
export var Component = function Component(_ref) {
  var className = _ref.className,
      hasRoundedCorners = _ref.hasRoundedCorners,
      isCircular = _ref.isCircular,
      isFluid = _ref.isFluid,
      label = _ref.label,
      placeholderImageUrl = _ref.placeholderImageUrl,
      imageTitle = _ref.imageTitle,
      isAvatar = _ref.isAvatar,
      sizes = _ref.sizes,
      imageUrl = _ref.imageUrl,
      srcSet = _ref.srcSet,
      willFill = _ref.willFill;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];

  useEffect(function () {
    setIsLoaded(false);
    setIsError(false);
  }, [imageUrl, placeholderImageUrl]);

  var onError = function onError() {
    setIsError(true);
    setIsLoaded(false);
  };

  var onLoad = function onLoad() {
    setIsError(false);
    setIsLoaded(true);
  };

  var style = {
    backgroundImage: isError || isLoaded ? '' : "url(".concat(placeholderImageUrl, ")")
  };
  return React.createElement("figure", {
    alt: imageTitle,
    className: classnames('responsive-image', className, {
      isLoaded: isLoaded || isError,
      isCircular: isCircular,
      willFill: willFill
    }),
    "data-testid": testid(),
    style: style
  }, isError && React.createElement(ImagePlaceholder, {
    "data-testid": testid('error-placeholder'),
    willFill: true
  }), React.createElement(SemanticImage, {
    avatar: isAvatar,
    circular: isCircular,
    "data-testid": testid('img'),
    fluid: isFluid,
    onError: onError,
    onLoad: onLoad,
    rounded: hasRoundedCorners,
    sizes: sizes,
    src: imageUrl,
    srcSet: srcSet,
    title: !isError ? imageTitle : ''
  }), label ? React.createElement(Paragraph, {
    "data-testid": testid('label')
  }, label) : null);
};
Component.displayName = 'ResponsiveImage';
Component.defaultProps = {
  className: '',
  hasRoundedCorners: false,
  imageTitle: IMAGE_TITLE,
  imageUrl: '',
  isAvatar: false,
  isCircular: false,
  willFill: false,
  isFluid: false,
  isLazyLoaded: true,
  label: null,
  placeholderImageUrl: undefined,
  sizes: null,
  srcSet: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: string,
  hasRoundedCorners: bool,
  imageTitle: string,
  imageUrl: string,
  isAvatar: bool,
  isCircular: bool,
  isFluid: bool,
  isLazyLoaded: bool,
  label: string,
  placeholderImageUrl: string,
  sizes: string,
  srcSet: string,
  willFill: bool
} : {};